<!--  -->
<template>
  <div>
    <div class="sale_box">
      <div class="dajsdw"><span style="color:red;">*</span>销售名称：</div>
      <el-input v-model="sale_name" placeholder="请输入销售名称" maxlength="5" style="width:200px;" />
    </div>
    <div class="sale_box">
      <div class="dajsdw"><span style="color:red;">*</span>销售微信号：</div>
      <el-input v-model="phone_vx_account" placeholder="请输入销售微信号" maxlength="20" style="width:200px;" />
    </div>
    <el-button size="mini" type="primary" :disabled="disabled" @click="dqweqsdw">确定</el-button>
  </div>
</template>

<script>
import { createdsawata, updateDatadaw } from '@/api/officialaccount.js'
export default {
  components: {},
  data() {
    return {
      sale_name: '',
      phone_vx_account: '',
      type: null, // 1是新增 2是编辑
      id: null,
      disabled: false
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    send(type, item) {
      console.log(item)
      this.type = type
      // eslint-disable-next-line eqeqeq
      if (type == 2) {
        this.sale_name = item.sale_name
        this.phone_vx_account = item.phone_vx_account
        this.id = item.id
      }
    },
    dqweqsdw() {
      // eslint-disable-next-line eqeqeq
      if (this.sale_name == '') {
        this.$message.error('请输入销售名称')
        return
      }
      // eslint-disable-next-line eqeqeq
      if (this.phone_vx_account == '') {
        this.$message.error('请输入销售微信号')
        return
      }
      // this.disabled = true
      // eslint-disable-next-line eqeqeq
      if (this.type == 1) {
        console.log('新增')

        createdsawata({
          sale_name: this.sale_name,
          phone_vx_account: this.phone_vx_account
        }).then((res) => {
          console.log('res', res)
          this.$emit('callback')
          this.$message({
            type: 'success',
            message: '新增成功!'
          })

          // setTimeout(() => {
          //   this.disabled = false
          // }, 1000)
        })
      } else {
        console.log('编辑')
        updateDatadaw({
          sale_name: this.sale_name,
          phone_vx_account: this.phone_vx_account,
          id: this.id
        }).then((res) => {
          this.$emit('callback')
          this.$message({
            type: 'success',
            message: '修改成功!'
          })

          // setTimeout(() => {
          //   this.disabled = false
          // }, 1000)
        })
      }
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.sale_box{
  display: flex;
  align-items: center;
  margin-bottom:20px
}
.dajsdw{
  width: 100px;
  text-align: right;
}
</style>
